import React, { ChangeEvent, ReactFragment, useEffect } from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableCell,
  TableRow,
  TableHead,
  Paper,
  TablePagination,
  TableFooter
} from "@mui/material";
import {
  StyledRow,
  StyledHeaderRow,
  StyledErrorContainer,
  StyledTableContainer
} from "./SimpleGrid.styles";
import { ImportantDevices } from "@mui/icons-material";
import theme from "helpers/mui-theme.helper";

interface SimpleGridProps {
  headers?: CellProps[];
  body: BodyProps[];
  paginationAction?: (currentPage?: number, itemsPerPage?: number) => void;
  totalList?: number;
  hidePagination?: boolean;
  manualRows?: boolean;
}
export interface CellProps {
  content: ReactFragment | JSX.Element | number;
  align?: "inherit" | "left" | "right" | "center";
}
export interface BodyProps {
  cells: CellProps[];
  id?: string;
  action?: (event: any) => void;
}
interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
}

export default function SimpleGrid(props: SimpleGridProps) {
  const { headers, body, paginationAction, totalList } = props;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  let rowCount = 0;
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rowCount) : 0;
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
    paginationAction!(rowsPerPage, newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value));
    paginationAction!(parseInt(event.target.value), 0);
    setPage(0);
  };

  return (
    <div>
      <TableContainer component={Paper}>
        <StyledTableContainer
        // sx={props.manualRows ? { maxHeight: theme.spacing(50) } : {}}
        >
          {body.length > 0 ? (
            <Table>
              <TableHead>
                <StyledHeaderRow>
                  {headers?.map((header) => {
                    return (
                      <TableCell align={header.align}>
                        {header.content}
                      </TableCell>
                    );
                  })}
                </StyledHeaderRow>
              </TableHead>

              <TableBody
                sx={
                  body.length > 0
                    ? {}
                    : {
                        textAlign: "center",
                        justifyContent: "center",
                        alignItems: "center"
                      }
                }
              >
                {body.map((row) => {
                  rowCount++;
                  return (
                    <StyledRow
                      key={`notifications-entry-${rowCount}`}
                      onClick={row.action}
                      hover
                    >
                      {row.cells.map((cell, cellIdx) => {
                        return (
                          <TableCell
                            key={`${row.id}-${cellIdx}`}
                            data-id={row.id}
                            align={cell.align}
                          >
                            {cell.content}
                          </TableCell>
                        );
                      })}
                    </StyledRow>
                  );
                })}
              </TableBody>
              {!props.manualRows && (
                <TableFooter>
                  <TableRow>
                    {!props.hidePagination && (
                      <TablePagination
                        rowsPerPageOptions={[100, 50, 25, 10, 5]}
                        colSpan={3}
                        count={totalList || 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: {
                            "aria-label": "rows per page"
                          },
                          native: true
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    )}
                  </TableRow>
                </TableFooter>
              )}
            </Table>
          ) : (
            <StyledErrorContainer>
              <ImportantDevices fontSize={"large"} />
              <h3>No Data Available</h3>
            </StyledErrorContainer>
          )}
        </StyledTableContainer>
      </TableContainer>
    </div>
  );
}
